import 'css-chunk:src/app/components/FilterList/fieldTypes/NumberEqual.scss';export default {
  "NumberEqual": "_NumberEqual_13d0h_1",
  "percentage": "_percentage_13d0h_4"
};